import React, { useState,useEffect ,useRef} from "react";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Box,TextField,CircularProgress
} from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { PieChart, Pie, Cell,  Tooltip, ResponsiveContainer } from "recharts";
import { IoIosPeople } from "react-icons/io";
import { PiStudentBold } from "react-icons/pi";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis} from 'recharts';
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../AuthProvider";


const TransportDashboard = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const {pId,oId,role,userId}=useAuth();
  // const [selectedDate, setSelectedDate] = useState("today");

  const [studentsCount, setstudentsCount] = useState({});
  

const navigate = useNavigate();
  const [isLoading,setIsLoading]=useState(false)

  //Notice board states
  const [notices, setNotices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingNotices, setLoadingNotices] = useState(true); // ✅ Define loading state

  const [dateRange, setDateRange] = useState("currentAcademicYear");


  // const [announcements, setAnnouncements] = useState([]);
  // const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);
  // const [error, setError] = useState(null);
  // const [currentIndex, setCurrentIndex] = useState(0);


  const [selectedBus, setSelectedBus] = useState("");
  const [busData, setBusData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  

  
  const marqueeRef = useRef(null);
  const [announcements, setAnnouncements] = useState({
    exams: [],
    notices: [],
    teachers: [],
    parents: []
  });  

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
  
 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
     useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);

  const [admissionusers, setAdmissionUsers] = useState([]);
  const [selectedAdmissionUsers, setSelectedAdmissionUsers] = useState('');
 const fetchAdminUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setAdmissionUsers(data);
            if (data.length > 0) {
              setSelectedAdmissionUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
     useEffect(() => {
  
        fetchAdminUsers();
  
}, [oId,pId]);



// useEffect(() => {
//   const fetchAnnouncements = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/Announcement/getAnnouncement/${oId}`);
//       if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

//       const data = await response.json();

//       const notices = data.noticeAnnouncementsDtos?.map(
//         (notice) => `📢 ${notice.title} on ${notice.purposeDate} at ${notice.time}`
//       ) || [];

     

//       const parents = data.parentAnnouncementDto?.map(
//         (meeting) => `👨‍👩‍👧 Parent-Teacher Meeting on ${meeting.purposeDate} at ${meeting.time}`
//       ) || [];

//       // If all categories are empty, show only one ["📢 No announcements available"]
//       const hasAnnouncements = notices.length || parents.length;
//       const defaultMessage = ["📢 No announcements available"];

//       setAnnouncements(
//         hasAnnouncements
//           ? { notices, parents }
//           : {  notices: defaultMessage, parents: defaultMessage }
//       );

//     } catch (error) {
//       console.error("Error fetching announcements:", error);
//       setAnnouncements({ notices: ["📢 No announcements available"], parents: ["📢 No announcements available"] });
//     }
//   };

//   fetchAnnouncements();
// }, [baseUrl, oId]);

useEffect(() => {
  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/Announcement/getAnnouncement/${oId}/${pId}`);
      if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

      const data = await response.json();

      const notices = data.noticeAnnouncementsDtos?.map(
        (notice) => `📢 ${notice.title} on ${notice.purposeDate} `
      ) || [];

      const parents = data.parentAnnouncementDto?.map(
        (meeting) => `👨‍👩‍👧 Parent-Teacher Meeting on ${meeting.purposeDate} `
      ) || [];

      const hasAnnouncements = notices.length || parents.length;

      // ✅ If no announcements, show only one combined message in notices and keep parents empty
      setAnnouncements(
        hasAnnouncements
          ? { notices, parents }
          : { notices: ["📢 No announcements available"], parents: [] }
      );

    } catch (error) {
      console.error("Error fetching announcements:", error);
      setAnnouncements({ notices: ["📢 No announcements available"], parents: [] });
    }
  };

  fetchAnnouncements();
}, [baseUrl, oId]);





//expenses bar graph states


const [expenseloading, setExpenseLoading] = useState(true);
const [filteredData, setFilteredData] = useState([]); 
const [originalData, setOriginalData] = useState([]);
const [loading, setLoading] = useState(false);

 const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);
const [expenseData, setExpenseData] = useState([]);

const getLastThreeMonths = (selectedMonth) => {
  const monthOrder = [
    'JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
    'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'
  ];
  
  const index = monthOrder.indexOf(selectedMonth.toUpperCase());
  const result = [];

  for (let i = 2; i >= 0; i--) {
    const monthIndex = (index - i + 12) % 12;
    result.push(monthOrder[monthIndex]);
  }

  return result; // Will return in order: [NOVEMBER, DECEMBER, JANUARY] when selectedMonth is JANUARY
};


  const fetchExpensesBarGraphData = async () => {

     // Check if UserId is available, if not, return early
      const UserId = userId || selectedUsers;
      if (!UserId) return; // ✅ Don't call API if there's no UserId

    setExpenseLoading(true);
    try {
      // const UserId = userId || selectedUsers;
      const response = await fetch(`${baseUrl}/api/principal/last-three-months-expenses/${UserId}/${oId}?selectedMonth=${selectedMonth}`);
      if (!response.ok) {                     
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      const months = getLastThreeMonths(selectedMonth);
      const formattedData = months
      .filter(month => data[month] !== undefined)
      .map((month, index) => ({
        name: month,
        value: data[month],
        color: index === 0 ? "#8884d8" : index === 1 ? "#82ca9d" : "#ff7300",
      }));
      setExpenseData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setExpenseLoading(false);
  };

  useEffect(() => {
    
  fetchExpensesBarGraphData();
}, [UserId, selectedUsers,selectedMonth]);

const handleMonthChange = (event) => {
  setSelectedMonth(event.target.value);
};


  const fetchNotices = async () => {
    setLoadingNotices(true); // Start loading
    try {
      const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
      const data = await response.json();
      // ✅ Sort notices by purposeDate (future dates first)
      data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

      setNotices(data); // Assuming the response is an array
    } catch (error) {
      console.error("Error fetching notices:", error);
    }finally {
      setLoadingNotices(false); // Stop loading
    }

  };
useEffect(() => {
  fetchNotices();
}, []);



//students api count
    useEffect(() => {
      // Fetch data from API
      const fetchData = async () => {
        if(!UserId) return;
        try {
          const today = new Date();

          const response = await fetch(`${baseUrl}/api/busAttendiesDashBoard/countAllStudentBusAttendance/${oId}/${UserId}`); // Replace with your API URL
          const data = await response.json();
          setstudentsCount(data); // Set the data from API
        } catch (error) {
          console.error("Error fetching data: ", error);
        } 
      };
      fetchData();
    }, [UserId]);




//BusFeeAmounts
const fetchBusFeeAmounts = async () => {
  // if(!selectedAdmissionUsers) return;
  try {
    let endpoint = "";
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    switch (dateRange) { // ✅ Changed to 'dateRange'
      // case "today":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${selectedAdmissionUsers}`;
      //   break;
      // case "yesterday":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllYesterdayBusPayments/${formattedDate}/bus_fee/${oId}/${selectedAdmissionUsers}`;
      //   break;
      // case "lastWeek":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastWeekBusPayments/${formattedDate}/bus_fee/${oId}/${selectedAdmissionUsers}`;
      //   break;
      // case "CurrentMonth":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllThisMonthBusPayments/${formattedDate}/bus_fee/${oId}/${selectedAdmissionUsers}`;
      //   break;
      // case "last6Months":
      //   endpoint = `${baseUrl}/api/admissionFeeDashBoard/adm/getAllLastSixMonthsBusPayments/${formattedDate}/bus_fee/${oId}/${selectedAdmissionUsers}`;
      //   break;
      case "today":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;
      case "yesterday":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllYesterdayBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;
      case "lastWeek":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastWeekBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;
      case "CurrentMonth":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllThisMonthBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;
      case "last6Months":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllLastSixMonthsBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;
      case "currentAcademicYear":
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllCurrentAcademicYearBusPayments/${formattedDate}/bus_fee/${oId}/${pId}`;
        break;

      default:
        endpoint = `${baseUrl}/api/admissionFeeDashBoard/pr/getAllTodayBusPayments/${formattedDate}/bus_fee/${oId}/${pId}}`;
        break;
    }

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();
    setBusFeeAmounts(data);
    
  } catch (error) {
    console.error("Error fetching tuition fee amounts:", error);
  }
};

useEffect(() => {
  fetchBusFeeAmounts();
}, [dateRange]); 


 // Filter notices based on search query
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    
  );
});

  // const handleDateChange = (event) => {
  //   setSelectedDate(event.target.value);
  // };

  // Filter data based on searchQuery
  const filteredResults = (Array.isArray(filteredData) ? filteredData : []).filter((item) => {
    const studentFirstName = item.studentFirstName ? item.studentFirstName.toLowerCase() : "";
    const studentLastName = item.studentLastName ? item.studentLastName.toLowerCase() : "";
    const fullName = `${studentFirstName} ${studentLastName}`.trim(); 
  
    return (
      fullName.includes(searchQuery.toLowerCase()) || 
      (item.admissionNumber && item.admissionNumber.includes(searchQuery)) // Ensure admissionNumber exists
    );
  });
  

  //select Bus API
    console.log("Filtered Data:", filteredResults);
      useEffect(() => {
        const fetchData = async () => {
          if(!UserId) return;
          try {
            const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers/${oId}/${UserId}`);
            if (!response.ok) throw new Error("Failed to fetch bus numbers");
      
            const data = await response.json();
            console.log("Fetched Bus Numbers:", data);
            setBusData(data || []);
              if (data.length > 0) {
                setSelectedBus(data[0].busNumber);
              }
          } catch (error) {
            console.error("Error fetching bus numbers:", error);
          }
        };
      
        fetchData();
      }, [oId,UserId]);


  //table list Api
    const fetchBusFeeDetails = async () => {
      if(!UserId) return;
      if (!selectedBus) {
        setTableLoading(false); // Ensure loading state is removed if no bus is selected
        return; 
      }
        try {
          setTableLoading(true); // Set loading to true before fetching data
          const response = await fetch(
            `${baseUrl}/api/busAttendiesDashBoard/getAllStudentsPresentListInBus/${oId}/${UserId}?busNumber=${selectedBus}`
          );
      
          if (!response.ok) throw new Error("Failed to fetch transactions");
      
          const data = await response.json();
          console.log("Bus Fee Data:", data);
      
          setFilteredData( data|| []);
        } catch (err) {
          console.error("Error fetching transactions:", err);
          setFilteredData([]); // Ensure table does not break on error
        } finally {
          setTableLoading(false); // Set loading to false after fetching (whether success or error)
        }
      };
      
      useEffect(() => {
        fetchBusFeeDetails();
      }, [selectedBus, oId,UserId]); 


const renderLabel = (entry) => {
  return entry.name;
};

const [busFeeAmounts, setBusFeeAmounts] = useState({});

const [tableDate, setTableDate] = useState("today");
const [pieChartDate, setPieChartDate] = useState("today");




const pieData = [
  
  // { name: "Total Bus Fee", value: busFeeAmounts.busFeePayments || 0, color: "#1976D2" },
  { name: "Bus Fee Paid", value: busFeeAmounts.busFeePaid  || 0, color: "#28a745" },
  { name: "Bus Fee Unpaid", value: busFeeAmounts.busFeeUnPaid  || 0, color: "#DC3545" }, 
];
// const total = pieData.reduce((acc, cur) => acc + cur.value, 0);

// Check if all values are zero to show fallback data
const hasData = pieData.some((item) => item.value > 0);

// Default placeholder data when no real data is available
const defaultPieData = [{ name: "No Data Available", value: 1, color: "#d3d3d3" }];

// Use actual data if available; otherwise, use fallback data
const finalPieData = hasData ? pieData : defaultPieData;






  

  return (
    <div style={{ backgroundColor: "#F5F5F6", minHeight: "100vh", padding: "10px" }}>
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>

      

      
      {/* Grid for Teachers and Students Stats */}
      <Grid container spacing={1} style={{ marginTop: "5%" }}>

  {/* Total students */}
  <Grid item xs={12} sm={4}>
  <Paper 
  style={{ ...cardStyle, borderBottom: `4px solid #007bff`, minHeight: "50px" ,cursor:'pointer'}}
  onClick={() => navigate("/TotalBusAttendanceList")} // Navigate to "/students"
  >
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#cce5ff", // Lighter background color for blue
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <IoIosPeople style={{ fontSize: "17px", color: "#007bff" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px" , fontWeight: "bold"}}>TOTAL STUDENTS</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#007bff", fontWeight: "bold" }}>
        {studentsCount.totalStudents || 0}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid> 


  {/* Present students */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #28a745`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate("/PresentBusAttendeesList")}  >
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#d4edda", // Lighter background color for green
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BsPersonCheckFill style={{ fontSize: "17px", color: "#28a745" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>PRESENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#28a745" , fontWeight: "bold"}}>
        {studentsCount.presentStudents || 0}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>


  {/* Absent students */}
 <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #dc3545`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate("/AbsentBusAttendeesList")} >
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#f8d7da", // Lighter background color for red
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BsFillPersonXFill style={{ fontSize: "17px", color: "#dc3545" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>ABSENT</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#dc3545", fontWeight: "bold" }}>
        {studentsCount.absentStudents || 0}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>

  {/* Total Bus Fees */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #007bff`, minHeight: "50px",cursor:'pointer' }} onClick={() => navigate("/BusFeesDetailsList")}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#cce5ff", // Lighter background color for blue
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PiStudentBold style={{ fontSize: "17px", color: "#007bff" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px" , fontWeight: "bold"}}>TOTAL BUS FEES </Typography>
        </Grid>
      </Grid>
      <Grid item>
  <Typography variant="h5" style={{ color: "#007bff", fontWeight: "bold" }}>
    ₹{busFeeAmounts.busFeePayments|| 0}
  </Typography>
</Grid>
    </Grid>
  </Paper>
</Grid>

  {/* Bus Fee Paid  */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #28a745`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate(`/PaidBusFeeList?dateRange=${dateRange}`)}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#d4edda", // Lighter background color for green
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
             
            }}
          >
            <BsPersonCheckFill style={{ fontSize: "17px", color: "#28a745" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>PAID</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#28a745", fontWeight: "bold" }}>
        ₹{busFeeAmounts.busFeePaid || 0}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>


  {/* Bus Fee Unpaid  */}
  <Grid item xs={12} sm={4}>
  <Paper style={{ ...cardStyle, borderBottom: `4px solid #dc3545`, minHeight: "50px" ,cursor:'pointer'}} onClick={() => navigate(`/UnpaidBusFeeList?dateRange=${dateRange}`)}>
    <Grid container alignItems="center" justifyContent="space-between" style={{ height: "100%" }}>
      <Grid item>
        <Grid container alignItems="center">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#f8d7da", // Lighter background color
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
            }}
          >
            <BsFillPersonXFill style={{ fontSize: "17px", color: "#dc3545" }} />
          </div>
          <Typography variant="h6" style={{ marginLeft: "8px", fontWeight: "bold" }}>UNPAID</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h5" style={{ color: "#dc3545", fontWeight: "bold" }}>
        ₹{busFeeAmounts.busFeeUnPaid|| 0}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
</Grid>


</Grid>



<marquee
    ref={marqueeRef} // Attach the ref to the marquee
    behavior="scroll"
    direction="right"
    scrollamount="5"
    onMouseEnter={() => marqueeRef.current && marqueeRef.current.stop()}
    onMouseLeave={() => marqueeRef.current && marqueeRef.current.start()}
    style={{
      marginTop: "13px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "4px 0",
      width: "100%",
      whiteSpace: "nowrap",
    }}
  >
    {[
      // ...announcements.exams,
      ...announcements.notices,
      // ...announcements.teachers,
      ...announcements.parents,
    ].map((announcement, index) => (
      <span key={index} style={{ marginRight: "20px" }}>
        {announcement}
      </span>
    ))}
  </marquee>

{/* Teachers Attendance Data */}

    

     
{/* Bus Student  */}

<     div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between" }}>

         {/* Card containing table title, date selector, and table */}

      <Paper style={{ flex: 2, padding: "5px", backgroundColor: "#FFFFFF", borderRadius: "8px" }}>

    <div style={{ flex: 2, marginLeft: "0px", paddingLeft: "10px", paddingRight: "10px", overflow: "auto" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
  {/* Title */}
  <Typography variant="h5" style={{ fontWeight: "bold", paddingLeft: "5px", marginTop: "5px" }}>
    List of Students Present in Bus
  </Typography>

  {/* Right section with "Total" and dropdown */}
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    {/* <Typography style={{ fontWeight: "bold" }}>Total-- 40/50</Typography> */}
    
        <FormControl style={{ width: "160px", marginTop:"7px" }} variant="outlined" size="small">
                    <InputLabel id="bus-select-label" style={{ fontSize: "12px" }}>
                      Select Bus
                    </InputLabel>
                    <Select
                      labelId="bus-select-label"
                      value={selectedBus}
                      onChange={(e) => setSelectedBus(e.target.value)}
                      label="Select Bus"
                      style={{ height: "35px", fontSize: "12px" }}
                    >
                      {busData.map((bus, index) => (
                       <MenuItem key={index} value={bus.busNumber}>
                          {bus.busNumberPlate}
                        </MenuItem>
                      ))}
                    </Select>
        </FormControl>
   
                               {/* <FormControl fullWidth style={{ width: "120px", marginTop:"7px" }} size="small">
                                 <InputLabel>Select Admission Admin</InputLabel>
                                 <Select
                                   value={selectedAdmissionUsers}
                                   onChange={(e) => setSelectedAdmissionUsers(e.target.value)}
                                   label="Select Admission Admin"
                                 >
                                   {admissionusers.map((user) => (
                                     <MenuItem key={user.userId} value={user.userId}>
                                       {user.userId}-{user.firstName} {user.lastName}
                                     </MenuItem>
                                   ))}
                                 </Select>
                               </FormControl> */}
                       

  </div>
</div>


  <TableContainer
  component={Paper}
  style={{
    maxHeight: "200px", // Reduced height from 280px to 200px
    overflowY: "auto",
    marginTop: "10px",
    position: "relative"
  }}
  // onMouseEnter={(e) => {
  //   e.currentTarget.querySelector('tbody').style.animationPlayState = "paused"; // Pause scrolling on hover
  // }}
  // onMouseLeave={(e) => {
  //   e.currentTarget.querySelector('tbody').style.animationPlayState = "running"; // Resume scrolling on hover
  // }}
>

    <Table stickyHeader>
      <thead>
        <tr>
          {["S.No", "Route No", "Bus No", "Driver Name", "Student Name", "PicUp Location", "Time", "Status"].map(
            (header) => (
              <th
                key={header}
                style={{
                  padding: "3px 8px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff9c4",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  fontSize: "12px",
                }}
              >
                {header}
              </th>
            )
          )}
        </tr>
      </thead>
      {/* style={{ animation: "scrollUp 15s linear infinite" }} */}
      <TableBody>
      {tableLoading ? (
        <TableRow>
          <TableCell colSpan={8} sx={{ textAlign: "center", padding: "20px" }}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CircularProgress />
              <Typography variant="body2" sx={{ mt: 1 }}>Loading Data...</Typography>
            </Box>
          </TableCell>
        </TableRow>
      ) : filteredResults.length === 0 ? (
        <TableRow>
          <TableCell colSpan={8} sx={{ textAlign: "center" }}>No data found.</TableCell>
        </TableRow>
      ) : (
        filteredResults.map((row, index) => (
          <TableRow key={row.id} 
            style={{ backgroundColor: "white", transition: "background-color 0.3s", height: "40px" }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
          >
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{index + 1}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.routeNumber}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.busNumber}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.firstName} {row.lastName}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.studentFirstName} {row.studentLastName}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.stopName}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>{row.inTime}</TableCell>
            <TableCell sx={{ textAlign: "center", borderRight: "1px solid #ddd", padding: "2px" }}>
              <Button 
                variant="contained" 
                sx={{ 
                  backgroundColor: row.status === "Present" ? "#67BB45" : "#F63E40", 
                  color: "#fff", fontWeight: "bold", borderRadius: "8px", padding: "1px 3px", fontSize: "10px", 
                  boxShadow: "none", cursor: "default" , "&:hover": {
                    backgroundColor: row.status === "Present" ? "#67BB45" : "#F63E40", // Prevent darkening effect
                  },
                }}
              >
                {row.status}
              </Button>
            </TableCell>
          </TableRow>
        ))
      )}
    </TableBody>
    </Table>
    {/* <style>
      {`
         @keyframes scroll {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
      `}
    </style> */}
  </TableContainer>
</div>
        </Paper>


{/* pie chart */}
        <div
  style={{
    flex: 1,
    marginLeft: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  }}
>
      <TableContainer
                        component={Paper}
                        style={{
                          height: "250px",
                          width: "100%",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "8px",
                          paddingTop: "1px",
                          boxShadow: "none",
                          border: "none",
                        }}
                      >
                        {/* Header */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 10px",
                          }}
                        >
                          <Typography variant="h6" style={{ fontWeight: "bold", color: "#333" }}>
                            Payments
                          </Typography>
      
                          {/* Date Range Dropdown */}
                          <FormControl variant="outlined" size="small" style={{ width: "120px" }}>
                            <InputLabel>Select Range</InputLabel>
                            <Select
                              value={dateRange}
                              onChange={(e) => setDateRange(e.target.value)}
                              label="Select Range"
                              style={{ height: "30px", fontSize: "12px" }}
                            >
                              <MenuItem value="today">Today</MenuItem>
                              <MenuItem value="yesterday">Yesterday</MenuItem>
                              <MenuItem value="lastWeek">Last Week</MenuItem>
                              <MenuItem value="CurrentMonth">Current Month</MenuItem>
                              <MenuItem value="last6Months">Last 6 Months</MenuItem>
                              {/* <MenuItem value="last365Days">Last 365 Days</MenuItem> */}
                              <MenuItem value="currentAcademicYear">Current Academic Year</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
      
                        {/* Table Content */}
                        <Table style={{ border: "none" }}>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                style={{
                                  padding: 0,
                                  height: "100%",
                                  borderBottom: "none",
                                  textAlign: "center",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "180px", // Fixed height to keep layout stable
                                    position: "relative",
                                  }}
                                >
                                  {/* Pie Chart Section */}
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <ResponsiveContainer width={210} height={200}>
                                      <PieChart>
                                        <Pie
                                          data={finalPieData}
                                          cx="50%"
                                          cy="50%"
                                          innerRadius={25}
                                          outerRadius={55}
                                          paddingAngle={2}
                                          dataKey="value"
                                          label={({ percent }) => (hasData ? `${(percent * 100).toFixed(1)}%` : "")}
                                        >
                                          {finalPieData.map((entry, index) => (
                                            <Cell key={index} fill={entry.color} />
                                          ))}
                                        </Pie>



                                        <Tooltip />
                                      </PieChart>
                                    </ResponsiveContainer>
                                  </div>
      
                                  {/* Labels on Right */}
                                  <div
                                    style={{
                                      paddingLeft: "15px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    {pieData.map((entry, index) => (
                                      <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                                        <div style={{ width: "12px", height: "12px", backgroundColor: entry.color, marginRight: "8px" }} />
                                        <Typography variant="body2" style={{ color: "#333", fontWeight: "bold", fontSize: "11px" }}>
                                          {entry.name}
                                        </Typography>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
 
        </div>

      </div>


{/* Notice Board and Expenses */}

                    <div style={{ display: "flex", marginTop: "5px", paddingTop: "5px", justifyContent: "space-between", height: "400px" }}>     
                                          
                     
                                           {/* //notice board */}
                                       <Paper
                                         style={{
                                           flex: 2,
                                           padding: "5px",
                                           backgroundColor: "#FFFFFF",
                                           borderRadius: "8px",
                                           marginRight: "5px",
                                           height: "100%",
                                           boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                         }}
                                       >
                                         <div
                                           style={{
                                             flex: 2,
                                             marginLeft: "0px",
                                             paddingLeft: "10px",
                                             paddingRight: "10px",
                                             overflow: "auto",
                                             height: "100%",
                                           }}
                                         >
                                           <div
                                             style={{
                                               display: "flex",
                                               justifyContent: "space-between",
                                               alignItems: "center",
                                               position: "sticky",
                                               top: "0",
                                               backgroundColor: "#FFFFFF",
                                               zIndex: 1,
                                             }}
                                           >
                                             <Typography
                                               variant="h5"
                                               style={{
                                                 fontWeight: "bold",
                                                 paddingLeft: "5px",
                                                 marginTop: "5px",
                                                 color: "#333",
                                               }}
                                             >
                                               Notice Board
                                             </Typography>
                                           </div>
                                           <GlobalStyles
                                             styles={{
                                               '.custom-sidebar-scrollbar': {
                                                 scrollbarWidth: 'thin',
                                                 scrollbarColor: 'grey #e0e0e0',
                                               },
                                               '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                                 width: '6px',
                                               },
                                               '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                                 background: '#f1f1f1',
                                               },
                                               '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                                 backgroundColor: 'grey',
                                                 borderRadius: '10px',
                                               },
                                               '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                                 backgroundColor: '#555',
                                               },
                                             }}
                                           />
                                           <div className="notice-container custom-sidebar-scrollbar" style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                                             {loadingNotices ? (
                                               <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                                                 <CircularProgress />
                                                 <Typography variant="body2" sx={{ mt: 1 }}>
                                                   Loading Notices...
                                                 </Typography>
                                               </Box>
                                             ) : filteredNotices.length === 0 ? (
                                               <Typography
                                                 variant="h6"
                                                 sx={{
                                                   textAlign: "center",
                                                   color: "#666",
                                                   width: "100%",
                                                   padding: "20px",
                                                   fontStyle: "italic",
                                                 }}
                                               >
                                                 No notices available.
                                               </Typography>
                                             ) : (
                                               filteredNotices.map((notice, index) => (
                                                 <Box
                                                   key={index}
                                                   sx={{
                                                     padding: "15px",
                                                     borderRadius: "10px",
                                                     boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                                     backgroundColor: "#D1E9F6",
                                                     position: "relative",
                                                     overflow: "hidden",
                                                     marginBottom: "10px",
                                                   }}
                                                 >
                                                   {new Date() - new Date(notice.purposeDate) < 24 * 60 * 60 * 1000 && (
                                                     <Box
                                                       sx={{
                                                         position: "absolute",
                                                         top: "0",
                                                         right: "0",
                                                         backgroundColor: "blue",
                                                         color: "#fff",
                                                         fontWeight: "bold",
                                                         fontSize: "0.75rem",
                                                         padding: "6px 12px",
                                                         textTransform: "uppercase",
                                                         borderTopRightRadius: "8px",
                                                         borderBottomLeftRadius: "8px",
                                                         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                       }}
                                                     >
                                                       New!
                                                     </Box>
                                                   )}
                     
                                                   <Box
                                                     sx={{
                                                       backgroundColor: "#4CAF50",
                                                       color: "white",
                                                       width:"110px",
                                                       padding: "5px 10px",
                                                       borderRadius: "5px",
                                                       fontWeight: "bold",
                                                       boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                       "&:hover": {
                                                         transform: "scale(1.05)",
                                                       },
                                                     }}
                                                   >
                                                     {notice.purposeDate}
                                                   </Box>
                     
                                                   <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginTop: "10px" }}>
                                                     {notice.title}
                                                   </Typography>
                                                   <Typography variant="body2" sx={{ marginTop: "5px", color: "#333", fontWeight: "bold" }}>
                                                     {notice.description}
                                                   </Typography>
                                                   <Typography variant="body2" sx={{ marginTop: "5px", fontStyle: "italic", color: "#444" }}>
                                                     Sent By: {notice.nameOfCreatedByNotice}, Time: {notice.time}
                                                   </Typography>
                                                 </Box>
                                               ))
                                             )}
                                           </div>
                                         </div>
                                       </Paper>
                     
                     
                     
                                   {/* Expenses bar chart */}
                     
                                   <div style={{ position: "relative", width: "40%" }}>
                       <TableContainer
                             style={{ backgroundColor: "#FFFFFF", borderRadius: "8px", paddingTop: "20px",height: "100%", }}
                           >
                         <div
                           style={{
                             display: "flex",
                             justifyContent: "space-between",
                             alignItems: "center",
                             padding: "0 0 10px 10px",
                             
                           }}
                         >
                           <Typography variant="h5" style={{ fontWeight: "bold", color: "#333" }}>
                             Expenses
                           </Typography>
                     
                           <div style={{ display: "flex", gap: "10px" }}>
                             {/* {isPrincipal && (
                               <FormControl fullWidth style={{ width: "150px" }} size="small">
                                 <InputLabel>Select Transport Admin</InputLabel>
                                 <Select
                                   value={selectedUsers}
                                   onChange={(e) => setSelectedUsers(e.target.value)}
                                   label="Select Transport Admin"
                                 >
                                   {users.map((user) => (
                                     <MenuItem key={user.userId} value={user.userId}>
                                       {user.userId}-{user.firstName} {user.lastName}
                                     </MenuItem>
                                   ))}
                                 </Select>
                               </FormControl>
                             )} */}
                             <FormControl style={{ width: "120px", paddingRight: "10px" }}>
                               <InputLabel id="month-select-label" style={{ fontSize: "12px" }}>
                                 Select Month
                               </InputLabel>
                               <Select
                                 labelId="month-select-label"
                                 value={selectedMonth}
                                 onChange={handleMonthChange}
                                 style={{ height: "35px", fontSize: "12px" }}
                                 label="Select Month"
                               >
                                 {months.map((month, index) => (
                                   <MenuItem key={index} value={month}>
                                     {month}
                                   </MenuItem>
                                 ))}
                               </Select>
                             </FormControl>
                           </div>
                         </div>
                     
                         <Table>
                           <TableBody>
                             <TableRow>
                               <TableCell style={{ padding: 0, height: "100%", textAlign: "center", borderBottom: "none" }}>
                                 {expenseData.length > 0 ? (
                                   <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                     <BarChart width={280} height={300} data={expenseData}>
                                       <XAxis dataKey="name" interval={0}/>
                                       <YAxis />
                                       <Tooltip />
                                       <Bar dataKey="value">
                                         {expenseData.map((entry, index) => (
                                           <Cell key={index} fill={entry.color} />
                                         ))}
                                       </Bar>
                                     </BarChart>
                                     <div
                                       style={{
                                         paddingLeft: "20px",
                                         display: "flex",
                                         flexDirection: "column",
                                       }}
                                     >
                                       {expenseData.map((entry, index) => (
                                         <div
                                           key={index}
                                           style={{
                                             display: "flex",
                                             alignItems: "center",
                                             marginBottom: "8px",
                                           }}
                                         >
                                           <div
                                             style={{
                                               width: "10px",
                                               height: "10px",
                                               backgroundColor: entry.color,
                                               marginRight: "5px",
                                             }}
                                           ></div>
                                           <Typography
                                             variant="body2"
                                             style={{
                                               color: "#333",
                                               fontWeight: "bold",
                                               fontSize: "14px",
                                             }}
                                           >
                                             {entry.name}
                                           </Typography>
                                         </div>
                                       ))}
                                     </div>
                                   </div>
                                 ) : (
                                   <Typography variant="body2" style={{ color: "#999", fontSize: "14px" }}>
                                     No expense data available
                                   </Typography>
                                 )}
                               </TableCell>
                             </TableRow>
                           </TableBody>
                         </Table>
                       </TableContainer>
                     </div>
                     
                     
                     
                    </div>

    </div>
  );
};

const cardStyle = {
  padding: "10px",
  position: "relative",
  borderRadius: "8px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  height: "40px",
};

export default TransportDashboard;